import axios from "axios";
import { setError, setLoading, setSummary } from "../slices/dashboard";

export const fetchDashboardSummary = (dateFrom, dateTo) => async (dispatch) => {
  dispatch(setLoading());
  try {
    const params = {};
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;

    const { data } = await axios.get("/api/dashboard/summary", { params });
    dispatch(setSummary(data));
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred reading dashboard data. Please try again later"
      )
    );
  }
};
